import {
  Swiper, Keyboard, Navigation,
} from 'swiper';
import { breakpoints } from '../../../resources/scripts/config/breakpoints';
import throttle from '../../../resources/scripts/utils/throttle';

const swiperContainerClass = '.amenities__list';
const combinedSlideClass = 'amenities__group-slide';

let swipers = [];
let width = window.innerWidth;

function setSlideContentHeight() {
  document.querySelectorAll(swiperContainerClass).forEach((el) => {
    const slideContents = el.querySelectorAll('.amenities__item-content');
    let maxHeight = 0;

    slideContents.forEach((content) => {
      // eslint-disable-next-line no-param-reassign
      content.style.height = '';

      if (content.offsetHeight > maxHeight) {
        maxHeight = content.offsetHeight;
      }
    });

    slideContents.forEach((content) => {
      // eslint-disable-next-line no-param-reassign
      content.style.height = `${maxHeight}px`;
    });
  });
}

function combineSlides() {
  document.querySelectorAll(swiperContainerClass).forEach((el) => {
    const swiperWrapper = el.querySelector('.amenities__swiper-wrapper');
    const slides = el.querySelectorAll('.amenities__item');
    const combinedSlides = [];

    for (let i = 0; i < slides.length; i += 2) {
      const combinedSlide = document.createElement('div');
      combinedSlide.className = `${combinedSlideClass} swiper-slide`;

      const firstSlide = slides[i];
      const secondSlide = slides[i + 1];

      combinedSlide.appendChild(firstSlide.cloneNode(true));

      if (secondSlide) {
        combinedSlide.appendChild(secondSlide.cloneNode(true));
      }

      combinedSlides.push(combinedSlide);
    }

    swiperWrapper.innerHTML = '';
    combinedSlides.forEach((slide) => {
      swiperWrapper.appendChild(slide);
    });
  });
}

function separateSlides() {
  document.querySelectorAll(swiperContainerClass).forEach((el) => {
    const swiperWrapper = el.querySelector('.amenities__swiper-wrapper');
    const combinedSlides = el.querySelectorAll(`.${combinedSlideClass}`);

    if (combinedSlides.length > 0) {
      const arraySlides = [];

      combinedSlides.forEach((combinedSlide) => {
        const slideChildren = combinedSlide.children;

        for (let i = 0; i < slideChildren.length; i++) {
          arraySlides.push(slideChildren[i].cloneNode(true));
        }
      });

      swiperWrapper.innerHTML = '';
      arraySlides.forEach((slide) => {
        swiperWrapper.appendChild(slide);
      });
    }
  });
}

function initSwiper(container) {
  // eslint-disable-next-line no-new
  const swiper = new Swiper(container, {
    modules: [Keyboard, Navigation],
    grabCursor: true,
    loop: true,
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      [breakpoints.lg]: {
        slidesPerView: 5,
        spaceBetween: 55,
      },
    },
    freeMode: true,
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: '.amenities__button-next',
      prevEl: '.amenities__button-prev',
    },
  });

  if (typeof container === 'string') {
    swipers = swiper;
  } else {
    swipers.push(swiper);
  }

  setSlideContentHeight();
}

function initAmenities(container) {
  if (typeof container === 'string') {
    document.querySelectorAll(container).forEach((el) => {
      initSwiper(el);
    });
  } else {
    initSwiper(container);
  }
}

function restartSwiper() {
  if (window.innerWidth !== width) {
    width = window.innerWidth;

    if (swipers.length) {
      swipers.forEach((swiper) => {
        swiper.destroy();
      });
    }

    if (width <= breakpoints.lg) {
      combineSlides();
    } else {
      separateSlides();
    }

    swipers = [];
    document.querySelectorAll(swiperContainerClass).forEach((el) => {
      initSwiper(el);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (width <= breakpoints.lg) {
    combineSlides();
  } else {
    separateSlides();
  }

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/amenities', ($block) => {
      initAmenities($block.find(swiperContainerClass)[0]);
    });
  } else {
    initAmenities(swiperContainerClass);
  }
});

window.addEventListener('resize', throttle(() => {
  restartSwiper();
}, 50));
